import React,{ Component } from "react";
import { Navigate } from 'react-router-dom';

class ApplyRedirect extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect:false,
          };
    }

componentDidMount(){
    localStorage.setItem('fromWhere','apply_now');
    sessionStorage.setItem('fromWhere', 'apply_now');
    this.setState({redirect:true});
    sessionStorage.setItem('applicationImage', 'images/home-active-contract-bg.png');
}


    render(){
        if (this.state.redirect) {
            return <Navigate push to="/application" />;
        }
        return(
            <div className="layout-fixed">
          
            </div>
        )
    }

}

export default ApplyRedirect;